"use client";



import GetStartedButton from "@/app/components/Utils/GetStartedButton";

const includedFeatures = [
    'Continuous Integration and Delivery',
    'Infrastructure as Code',
    'Security Automation',
    'Monitoring and Observability',
]

export default function DevOpsDevSecOpsPricing() {
    return (
        <div className="bg-white py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-4xl sm:text-center">
                    <h2 className="text-5xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-6xl sm:text-balance">
                        DevOps and DevSecOps Solutions
                    </h2>
                    <p className="mx-auto mt-6 max-w-2xl text-lg font-medium text-pretty text-gray-500 sm:text-xl/8">
                        Accelerate your development lifecycle while enhancing security with our integrated DevOps and DevSecOps practices that streamline deployment and protect your applications.
                    </p>
                </div>
                <div className="mx-auto mt-16 max-w-2xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
                    <div className="p-8 sm:p-10 lg:flex-auto">
                        <h3 className="text-3xl font-semibold tracking-tight text-gray-900">Enterprise DevSecOps</h3>
                        <p className="mt-6 text-base/7 text-gray-600">
                            Our DevOps and DevSecOps solutions integrate security into every phase of the development lifecycle, enabling faster delivery with built in compliance and reduced vulnerability risks.
                        </p>
                        <div className="mt-10 flex items-center gap-x-4">
                            <h4 className="flex-none text-sm/6 font-semibold text-blue-600">What's included</h4>
                            <div className="h-px flex-auto bg-gray-100" />
                        </div>
                        <ul role="list" className="mt-8 grid grid-cols-1 gap-4 text-sm/6 text-gray-600 sm:grid-cols-2 sm:gap-6">
                            {includedFeatures.map((feature) => (
                                <li key={feature} className="flex gap-x-3">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-6 w-5 flex-none text-blue-600"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                    </svg>
                                    {feature}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:shrink-0">
                        <div
                            className="rounded-2xl bg-gray-50 py-10 text-center ring-1 ring-gray-900/5 ring-inset lg:flex lg:flex-col lg:justify-center lg:py-16">
                            <div className="mx-auto max-w-xs px-8">
                                <p className="text-base font-semibold text-gray-600">Investment that pays for itself
                                    Custom Pricing</p>
                                <div className="mt-2 flex justify-center">
                                    <GetStartedButton/>
                                </div>
                                <p className="mt-6 text-xs/5 text-gray-600">
                                    Custom solutions available to match your specific business needs that pays for
                                    itself
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}